import React, { FC, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select'
import {
  fetchData,
  getEncryptedRoute,
  getTranslatedValue,
  hasSpecialCharacters,
  isSpecificSpecialCharacters,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import { ToastContainer } from 'react-toastify'
import { AddSpaceHeader } from './AddSpaceHeader'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const AddSpaceBasicInfo: FC = () => {
  let t = Tr()
  const location = useLocation()
  const { menuId } = useMenuIdPermissions()
  const lang = useLang()

  const editSpacerentalId = (location.state as any)?.spacerentalId || ''
  const vendorId2 = (location.state as any)?.vendorId || ''

  if (vendorId2 != '' && vendorId2 != null) {
    sessionStorage.setItem('vendor', vendorId2)
    sessionStorage.setItem('selectedVendor', vendorId2)
  }
  const vendorId = sessionStorage.getItem('vendor')

  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false)
  const [spaceRenatalDetails, setSpacerentalDetails] = useState([])
  const [spaceNameEN, setSpaceNameEN] = useState('')
  const [spaceNameRU, setSpaceNameRU] = useState('')
  const [spaceNameUZ, setSpaceNameUZ] = useState('')
  const [contactPersonName, setContactPersonName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [hostName, setHostName] = useState('')
  const [vendorList, setVendorList] = useState([])
  const [selectedVendor, setSelectedVendor] = useState(null)

  // sub category list state start
  const [subCategoryList, setSubCategoryList] = useState([])
  const [subCategorySelectedOptions, setSubCategorySelectedOptions] = useState<any>()
  // sub category list state end
  const specialCharacterRegex = /^[a-zA-Z\u0400-\u04FF<>,-."'*()`’ ]*$/;

  // service language list state start  
  const [primaryLanguageList, setPrimaryLanguageList] = useState([
    { value: 'English', label: 'English' },
    { value: 'Russian', label: 'русский' },
    { value: 'Uzbek', label: 'O‘zbekcha' },
  ])
  const [primaryLanguageSelectedOptions, setPrimaryLanguageSelectedOptions] = useState<any>({
    value: 'English',
    label: 'English',
  })
  sessionStorage.setItem('primaryLanguage', primaryLanguageSelectedOptions.value)

  // service language list state end
  const changePrimaryLanguage = (val: any) => {
    setPrimaryLanguageSelectedOptions(val)
    removeError('primaryLanguage')
    sessionStorage.setItem('primaryLanguage', val.value)
  }

  const [socialMediaChannelList, setSocialMediaChannelList] = useState([
    { label: 'Instagram', value: 'Instagram' },
    { label: 'Facebook', value: 'Facebook' },
    { label: 'Linkedin', value: 'Linkedin' },
    { label: 'TikTok', value: 'TikTok' },
    { label: 'YouTube', value: 'YouTube' },
    { label: 'Website', value: 'Website' },
  ])

  const [socialMediaFields, setSocialMediaFields] = useState([
    { socialMediaType: '', socialMediaLink: '' },
  ])

  const handleAddField = () => {
    setSocialMediaFields([...socialMediaFields, { socialMediaType: '', socialMediaLink: '' }])
  }

  const handleRemoveField = (index: any) => {
    const updatedFields = socialMediaFields.filter((_, i) => i !== index)
    setSocialMediaFields(updatedFields)
  }

  const handleChange = (index: any, field: any, value: any) => {
    const updatedFields = [...socialMediaFields] as any
    updatedFields[index][field] = value
    setSocialMediaFields(updatedFields)
  }
  const handleVendorChange = (e: any) => {
    setSelectedVendor(e)
    sessionStorage.setItem('vendor', e.value)
  }

  const getFilteredOptions = (currentIndex: any) => {
    const selectedValues = socialMediaFields.map((field, index) =>
      index !== currentIndex ? field.socialMediaType : ''
    )
    return socialMediaChannelList.filter((option) => !selectedValues.includes(option.value))
  }
  // set error state
  const [error, setError] = useState([
    {
      subCategoryId: '',
      spaceNameEN: '',
      spaceNameRU: '',
      spaceNameUZ: '',
      contactPersonName: '',
      email: '',
      phoneNumber: '',
      primaryLanguage: '',
      hostName: '',
      vendorId: '',
    },
  ])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any
    tmp[0][err] = ''
    setError(tmp)
  }

  //   space Subcategory list api call
  const spaceSubcategoryAPIcall = async () => {
    var res = await fetchData('vendor/public/spaceSubcategoryList', [])

    if (res.status == '200') {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.subcategoryId, label: getTranslatedValue(lang, val, '_name') })
      })
      setSubCategoryList(opt)
    } else {
      toasterrormsg(res.message)
    }
  }

  const getvendorlist = async () => {
    let param: any = {
      categoryId: '4',
    }

    var response: any = await fetchData('admin/vendorList', param)

    if (response.status == '200') {
      var data = response.data.map((item: any) => {
        return { value: item.vendorId, label: item.fullName }
      })
      setVendorList(data)
      var tmpven: any = sessionStorage.getItem('selectedVendor')
      var selvendor: any = data.filter((item: any) => item.value == tmpven)
      setSelectedVendor(selvendor.length > 0 ? selvendor[0] : null)
      if (editSpacerentalId != '') {
      }
    } else {
      toasterrormsg(response.message)
    }
  }

  // validation function
  const validate = () => {
    var isValid = true
    var errorTmp = [...error]

    if (
      subCategorySelectedOptions == '' ||
      subCategorySelectedOptions == null ||
      subCategorySelectedOptions == undefined
    ) {
      errorTmp[0].subCategoryId = t('Space Type Is Required')
      isValid = false
    }
    if (primaryLanguageSelectedOptions.value == 'English') {
      if (
        spaceNameEN.trim() == '' ||
        spaceNameEN.trim() == null ||
        spaceNameEN.trim() == undefined
      ) {
        errorTmp[0].spaceNameEN = t('Space Name Is Required')
        isValid = false
      } else if (!isSpecificSpecialCharacters(spaceNameEN.trim(), specialCharacterRegex)) {
        errorTmp[0].spaceNameEN = t("Only <>,.'*() ` ’ - type Of Special Characters Are Allowed.")
        isValid = false
      }
    } else if (primaryLanguageSelectedOptions.value == 'Russian') {
      if (
        spaceNameRU.trim() == '' ||
        spaceNameRU.trim() == null ||
        spaceNameRU.trim() == undefined
      ) {
        errorTmp[0].spaceNameRU = t('Space Name Is Required')
        isValid = false
      } else if (!isSpecificSpecialCharacters(spaceNameRU.trim(), specialCharacterRegex)) {
        errorTmp[0].spaceNameRU = t("Only <>,.'*() ` ’ - type Of Special Characters Are Allowed.")
        isValid = false
      }
    } else if (primaryLanguageSelectedOptions.value == 'Uzbek') {
      if (
        spaceNameUZ.trim() == '' ||
        spaceNameUZ.trim() == null ||
        spaceNameUZ.trim() == undefined
      ) {
        errorTmp[0].spaceNameUZ = t('Space Name Is Required')
        isValid = false
      } else if (!isSpecificSpecialCharacters(spaceNameUZ.trim(), specialCharacterRegex)) {
        errorTmp[0].spaceNameUZ = t("Only <>,.'*() ` ’ - type Of Special Characters Are Allowed.")
        isValid = false
      }
    }
    if (
      contactPersonName.trim() == '' ||
      contactPersonName.trim() == null ||
      contactPersonName.trim() == undefined
    ) {
      errorTmp[0].contactPersonName = t('Contact Person Name Is Required')
      isValid = false
    } else if (!isSpecificSpecialCharacters(contactPersonName.trim(), specialCharacterRegex)) {
      errorTmp[0].contactPersonName = t('Contact Person Name Is Not Valid')
      isValid = false
    }
    if (hostName.trim() == '' || hostName.trim() == null || hostName.trim() == undefined) {
      errorTmp[0].hostName = t('Host Name Is Required')
      isValid = false
    } else if (!isSpecificSpecialCharacters(hostName.trim())) {
      errorTmp[0].hostName = t("Only <>,.'*() ` ’ -type Of Special Character Are Allow.")
      isValid = false
    }
    if (email == '' || email == undefined || email == null) {
      errorTmp[0].email = t('Email Is Required')
      isValid = false
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}(?:\.[A-Z]{2,})?$/i.test(email)) {
      errorTmp[0].email = t('Email Is Not Valid.')
      isValid = false
    }
    if (phoneNumber == '' || phoneNumber == undefined || phoneNumber == null) {
      errorTmp[0].phoneNumber = t('Mobile Number Is Required')
      isValid = false
    } else if (!/^\d+$/.test(phoneNumber)) {
      errorTmp[0].phoneNumber = t('Only Number Is Allowed')
      isValid = false
    } else if (
      ((phoneNumber != '' && phoneNumber != undefined) || phoneNumber != null) &&
      phoneNumber.length < 8
    ) {
      errorTmp[0].phoneNumber = t('Minimum 8 Digit Required')
      isValid = false
    }

    setError(errorTmp)
    return isValid
  }
  // add restaurant api call
  const addSpaceApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param: any = {
        vendorId: String(vendorId),
        en_name: spaceNameEN,
        ru_name: spaceNameRU,
        uz_name: spaceNameUZ,
        subcategoryId: subCategorySelectedOptions.value,
        hostName: hostName,
        primaryLanguage: primaryLanguageSelectedOptions.value,
        email: email,
        phoneNo: phoneNumber,
        contact_person_name: contactPersonName,
        socialMediaChannels: socialMediaFields,
      }

      var res = await fetchData('vendor/public/addSpace', param)
      if (res.status == '200') {
        toastsuccessmsg('Basic Information Saved Successfully!')
        var data = res.data[0]

        const state = {
          spacerentalId: data['spacerentalId'],
        }
        setTimeout(() => {
          navigate('../addspacelocation/', { state })
          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        setDisable(false)

        toasterrormsg(res.message)
      }
    }
  }
  // edit restaurant api call
  const editSpaceApi = async () => {
    if (validate()) {
      setDisable(true)
      setLoading(true)
      let param: any = {
        vendorId: String(vendorId),
        spacerentalId: String(editSpacerentalId),
        en_name: spaceNameEN,
        ru_name: spaceNameRU,
        uz_name: spaceNameUZ,
        subcategoryId: subCategorySelectedOptions.value,
        hostName: hostName,
        primaryLanguage: primaryLanguageSelectedOptions.value,
        email: email,
        phoneNo: phoneNumber,
        contact_person_name: contactPersonName,
        socialMediaChannels: socialMediaFields,
      }

      var res = await fetchData('vendor/public/addSpace', param)
      if (res.status == '200') {
        toastsuccessmsg('Basic Information Saved Successfully!')
        var data = res.data[0]

        const state = {
          spacerentalId: data['spacerentalId'],
        }
        setTimeout(() => {
          navigate(getEncryptedRoute('../addspacelocation/', { menuId: menuId }), { state })
          setDisable(false)
          setLoading(false)
        }, 1500)
      } else {
        setDisable(false)
        toasterrormsg(res.message)
      }
    }
  }

  // space Details api call
  const spaceDetailsApiCall = async () => {
    var param: any = {
      spacerentalId: String(editSpacerentalId),
    }
    var response: any = await fetchData('vendor/public/spaceDetails', param)

    if (response.status == '200') {
      setSpacerentalDetails(response.data)
      var data = response.data[0]
      setPrimaryLanguageSelectedOptions({
        value: data.primaryLanguage,
        label: `${data.primaryLanguage}`,
      })
      var subCategory: any = []
      data.subcategory.map((val: any) => {
        subCategory.push({ value: val.subcategoryId, label: getTranslatedValue(lang, val, '_name') })
      })
      setSubCategorySelectedOptions(subCategory[0])
      setHostName(data.hostName)
      setSpaceNameEN(data.en_name)
      setSpaceNameRU(data.ru_name)
      setSpaceNameUZ(data.uz_name)
      setContactPersonName(data.contact_person_name)
      setEmail(data.email)
      setPhoneNumber(data.phoneNo)
      setSocialMediaFields(data.socialMediaChannels)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    getvendorlist()
    spaceSubcategoryAPIcall()
    if (editSpacerentalId != '') {
      spaceDetailsApiCall()
    }
  }, [])
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>
        {editSpacerentalId != '' ? t('Edit Space') : t('Add Space')}
      </PageTitle>
      <AddSpaceHeader spacerentalId={editSpacerentalId} />
      <div className='d-flex flex-column flex-column-fluid'>
        {/* <!--begin::Content--> */}
        <div id='kt_app_content' className='app-content flex-column-fluid'>
          {/* <!--begin::Form--> */}
          <div className='form d-flex flex-column flex-lg-row'>
            {/* <!--begin::Main column--> */}
            <div className='d-flex flex-column flex-row-fluid gap-7 gap-lg-10'>
              {/* <!--begin::Tab content--> */}
              <div className='tab-content'>
                {/* <!--begin::Tab pane--> */}
                <div
                  className='tab-pane fade show active'
                  id='kt_ecommerce_add_product_general'
                  role='tab-panel'
                >
                  <div className='d-flex flex-column'>
                    {/* <!--begin::General options--> */}
                    <div className='card card-flush py-4'>
                      {/* <!--begin::Card header--> */}
                      <div className='card-header d-flex'>
                        {/* <!--begin::Card title--> */}
                        <div className='card-title'>
                          <h2>{t('Space Basic Information')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {spaceRenatalDetails.length != 0 ? (
                            <>
                              {spaceRenatalDetails.map((completedSteps: any, index: any) => {
                                var percentage = 0
                                if (completedSteps['completedSteps']['basicInfo']) {
                                  percentage = 10
                                }
                                if (completedSteps['completedSteps']['location']) {
                                  percentage = 20
                                }
                                if (completedSteps['completedSteps']['propertyDetail']) {
                                  percentage = 40
                                }
                                if (completedSteps['completedSteps']['rentableSpace']) {
                                  percentage = 50
                                }
                                if (completedSteps['completedSteps']['photos']) {
                                  percentage = 60
                                }
                                if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                  percentage = 70
                                }
                                if (completedSteps['completedSteps']['availability']) {
                                  percentage = 80
                                }
                                if (completedSteps['completedSteps']['policies']) {
                                  percentage = 90
                                }
                                if (completedSteps['completedSteps']['financeAndLegal']) {
                                  percentage = 100
                                }
                                return (
                                  <>
                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                      <span className='fw-bold fs-6'>{t('Completion')}</span>
                                      <span className='fw-bolder fs-6'>{percentage}%</span>
                                    </div>
                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                      <div
                                        className='bg-success rounded h-5px'
                                        role='progressbar'
                                        style={{ width: `${percentage}%` }}
                                      ></div>
                                    </div>
                                  </>
                                )
                              })}
                            </>
                          ) : (
                            <>
                              <div className='d-flex justify-content-between w-100 mt-auto'>
                                <span className='fw-bold fs-6'>{t('Completion')}</span>
                                <span className='fw-bolder fs-6'>0%</span>
                              </div>
                              <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                <div
                                  className='bg-success rounded h-5px'
                                  role='progressbar'
                                  style={{ width: '0%' }}
                                ></div>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-10'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Select Vendor')}</label>

                            <Select
                              name='vendor'
                              id='vendorId'
                              isDisabled={editSpacerentalId != ''}
                              placeholder={t('Select Vendor')}
                              isSearchable={true}
                              options={vendorList}
                              value={selectedVendor}
                              onChange={handleVendorChange}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].vendorId}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>
                              {t('Primary Language')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='primaryLanguage[]'
                              id='primaryLanguage'
                              placeholder={t('Select Primary Language')}
                              isSearchable={true}
                              options={primaryLanguageList}
                              value={primaryLanguageSelectedOptions}
                              onChange={(e: any) => {
                                changePrimaryLanguage(e)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].primaryLanguage}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>{t('Space Type')}</label>
                            {/* <!--end::Label--> */}
                            <Select
                              name='subCategory[]'
                              id='subCategoryListId'
                              placeholder={t('Select Space Type')}
                              isSearchable={true}
                              options={subCategoryList}
                              value={subCategorySelectedOptions}
                              onChange={(e: any) => {
                                setSubCategorySelectedOptions(e)
                                removeError('subCategoryId')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].subCategoryId}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label'>{t('Host Name')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='hostName'
                              className='form-control mb-2'
                              placeholder={t('Host Name')}
                              value={hostName}
                              onChange={(e) => {
                                setHostName(e.target.value)
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].hostName}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      <div className='card-body pt-0'>
                        {primaryLanguageSelectedOptions.value == 'English' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Space Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameEN}
                                  onChange={(e) => {
                                    setSpaceNameEN(e.target.value)
                                    removeError('spaceNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].spaceNameEN}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Space Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameRU}
                                  onChange={(e) => {
                                    setSpaceNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Space Name (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameUZ}
                                  onChange={(e) => {
                                    setSpaceNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguageSelectedOptions.value == 'Russian' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Space Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameRU}
                                  onChange={(e) => {
                                    setSpaceNameRU(e.target.value)
                                  }}
                                />
                                <div className='text-danger fw-bold'>{error[0].spaceNameRU}</div>
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Space Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameEN}
                                  onChange={(e) => {
                                    setSpaceNameEN(e.target.value)
                                    removeError('spaceNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>{t('Space Name (Uzbek)')}</label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameUZ}
                                  onChange={(e) => {
                                    setSpaceNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                        {primaryLanguageSelectedOptions.value == 'Uzbek' && (
                          <>
                            {/* <!--begin::Input group--> */}
                            <div className='row'>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='required fs-4 form-label'>
                                  {t('Space Name (Uzbek)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameUZ'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameUZ}
                                  onChange={(e) => {
                                    setSpaceNameUZ(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                                <div className='text-danger fw-bold'>{error[0].spaceNameUZ}</div>
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Space Name (Russian)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameRU'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameRU}
                                  onChange={(e) => {
                                    setSpaceNameRU(e.target.value)
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                              <div className='col-lg-4 my-3'>
                                {/* <!--begin::Label--> */}
                                <label className='fs-4 form-label'>
                                  {t('Space Name (English)')}
                                </label>
                                {/* <!--end::Label--> */}
                                {/* <!--begin::Input--> */}
                                <input
                                  type='text'
                                  name='spaceNameEN'
                                  className='form-control mb-2'
                                  placeholder={t('Space Name')}
                                  value={spaceNameEN}
                                  onChange={(e) => {
                                    setSpaceNameEN(e.target.value)
                                    removeError('spaceNameEN')
                                  }}
                                />
                                {/* <!--end::Input--> */}
                              </div>
                            </div>
                            {/* <!--end::Input group--> */}
                          </>
                        )}
                      </div>
                      {/* <!--end::Card body--> */}
                      {/* <!--begin::Card body--> */}
                      <div className='card-body pt-0'>
                        {/* <!--begin::Input group--> */}
                        <div className='row'>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='required fs-4 form-label'>
                              {t('Contact Person Name')}
                            </label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='contactPersonName'
                              className='form-control mb-2'
                              placeholder={t('Contact Person Name')}
                              value={contactPersonName}
                              onChange={(e) => {
                                setContactPersonName(e.target.value)
                                removeError('contactPersonName')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].contactPersonName}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Email')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='email'
                              className='form-control mb-2'
                              placeholder={t('Email')}
                              value={email}
                              onChange={(e) => {
                                setEmail(e.target.value)
                                removeError('email')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].email}</div>
                          </div>
                          <div className='col-lg-4 my-3'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>{t('Phone Number')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <input
                              type='text'
                              name='phoneNumber'
                              className='form-control mb-2'
                              placeholder={t('Phone Number')}
                              value={phoneNumber}
                              onChange={(e) => {
                                setPhoneNumber(e.target.value)
                                removeError('phoneNumber')
                              }}
                            />
                            {/* <!--end::Input--> */}
                            <div className='text-danger fw-bold'>{error[0].phoneNumber}</div>
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      <div className='card-body pt-0'>
                        <div className='row'>
                          <div className='col-lg-12'>
                            {/* <!--begin::Label--> */}
                            <label className='fs-4 form-label required'>
                              {t('Social Media Channel')}
                            </label>
                            {/* <!--end::Label--> */}
                          </div>
                        </div>
                        {socialMediaFields.map((field, index) => (
                          <div className='row' key={index}>
                            <div className='col-lg-4 my-3'>
                              <Select
                                name='socialMediaChannels[]'
                                id={`socialMediaChannels-${index}`}
                                placeholder={t('Select Social Media Channels')}
                                isSearchable={true}
                                options={getFilteredOptions(index)}
                                value={socialMediaChannelList.find(
                                  (option) => option.value === field.socialMediaType
                                )}
                                onChange={(selectedOption: any) =>
                                  handleChange(index, 'socialMediaType', selectedOption.value)
                                }
                              />
                            </div>
                            <div className='col-lg-4 my-3'>
                              <input
                                type='text'
                                className='form-control mb-2'
                                name='socialMediaLinks'
                                id={`socialMediaLinks-${index}`}
                                placeholder='Social Media Link'
                                value={field.socialMediaLink}
                                onChange={(e) =>
                                  handleChange(index, 'socialMediaLink', e.target.value)
                                }
                              />
                            </div>
                            <div className='col-lg-4 my-3'>
                              <button
                                className='btn btn-success mx-1'
                                type='button'
                                onClick={handleAddField}
                              >
                                +
                              </button>
                              {socialMediaFields.length > 1 && index != 0 && (
                                <button
                                  className='btn btn-danger mx-1'
                                  type='button'
                                  onClick={() => handleRemoveField(index)}
                                >
                                  -
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className='d-flex justify-content-end'>
                {/* <!--begin::Button--> */}
                <Link
                  to={getEncryptedRoute('../viewspacerentals/', { menuId: menuId })}
                  id='kt_ecommerce_add_product_cancel'
                  className='btn btn-light me-5'
                >
                  {t('Cancel')}
                </Link>
                {/* <!--end::Button--> */}
                <button
                  type='submit'
                  disabled={disable}
                  className='btn btn-primary'
                  onClick={() => {
                    if (editSpacerentalId !== '') {
                      editSpaceApi()
                    } else {
                      addSpaceApi()
                    }
                  }}
                >
                  <span className='indicator-label'>{t('Next')}</span>
                  {loading && (
                    <span
                      className='spinner-border spinner-border-sm mx-2'
                      role='status'
                      aria-hidden='true'
                    ></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { AddSpaceBasicInfo }
